<div class="cid-s48MCQYojq flex flex-col items-center justify-center w-full" *ngIf="!isPortal">

	<section class="w-fullheader1 cid-s48MCQYojq mbr-fullscreen mbr-parallax-background " data-bs-version="5.1"
		id="header1-f">

		<div class="mbr-overlay" style="opacity: 0; background-color: rgb(255, 255, 255);"></div>

		<div class="align-center container">
			<div>
<!--				
<div class="globe-container">
  <canvas id="canvasOne" style="width: 100%; height: 100%;">
    Your browser does not support HTML5 Canvas.
  </canvas>
</div>
-->
			
			<div class="home-image-size">
				  <img src="assets/common/images/VeteransOfHope_Logo.png"> 
				<!-- <img src="assets/common/images/tiverton-background-network.png">-->
			</div>
				<div>
					<br>
					<br>
					<br>
					<br>
					<br>
					<div style="color: gold;">
						<h1>
							<strong>Welcome to our Website</strong>
						</h1>
					</div>
					<br>
					<div style="color: white;">
						<p>The Social Network for Change!</p>
					</div>
					<br>
					<div class="mbr-section-btn mt-3">
						<a class="btn btn-white display-4" id="myLink" href="#" (click)="redirectToProfile();">Enter</a>
					</div>
				</div>
			</div>
		</div>
	</section>
</div>

<ng-container *ngIf="isPortal">
	<router-outlet></router-outlet>
</ng-container>
